<div id="content">
  <div class="grid-item-full">
    @if (loading) {
      <div>
        <mat-spinner class="center"></mat-spinner>
      </div>
    } @else {
      <mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="Firstname">
          <mat-header-cell *matHeaderCellDef> Vorname </mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.firstname}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Lastname">
          <mat-header-cell *matHeaderCellDef> Nachname </mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.lastname}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Birthday">
          <mat-header-cell *matHeaderCellDef> Geburtsdatum </mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.birthday | date: 'dd.MM.yyyy'}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Gender">
          <mat-header-cell *matHeaderCellDef> Geschlecht </mat-header-cell>
          <mat-cell *matCellDef="let element">{{element | gender}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Address">
          <mat-header-cell *matHeaderCellDef> Adresse </mat-header-cell>
          <mat-cell *matCellDef="let element">{{element | address}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Actions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element" class="actions">
            <mat-icon (click)="delete(element)">delete</mat-icon>
            <mat-icon (click)="import(element)">login</mat-icon>
          </mat-cell>
        </ng-container>
        <mat-header-row
          *matHeaderRowDef="[
            'Firstname',
            'Lastname',
            'Birthday',
            'Gender',
            'Address',
            'Actions'
          ]"></mat-header-row>
        <mat-row
          *matRowDef="
            let row;
            columns: [
            'Firstname',
            'Lastname',
            'Birthday',
            'Gender',
            'Address',
            'Actions'
            ]
          "></mat-row>
      </mat-table>
    }

  </div>
  <div class="grid-item">
    <input
      matInput
      id="pipelineFilter"
      (keyup)="applyFilter($event)"
      placeholder="Filtern" />
    </div>
    <div class="grid-item"></div>
  </div>
